<template>
  <MDBModal
    tabindex="-1"
    labelledby="globalModalLabel"
    v-model="modalState"
    v-bind="$attrs"
    :centered="isCentered"
  >
    <template v-if="slots['modal-close-btn']">
      <div :class="`modal-header ${props.variant}`">
        <MDBModalTitle :bold="isTitleBold">
          <slot name="modal-title" />
        </MDBModalTitle>

        <slot name="modal-close-btn" />
      </div>
    </template>
    <template v-else>
      <MDBModalHeader :class="props.variant" :close="hasCloseButton">
        <MDBModalTitle :bold="isTitleBold">
          <slot name="modal-title" />
        </MDBModalTitle>
      </MDBModalHeader>
    </template>
    <MDBModalBody v-if="!props.noBody">
      <slot name="modal-body" />
    </MDBModalBody>
    <MDBModalFooter>
      <slot name="modal-footer" />
    </MDBModalFooter>
  </MDBModal>
</template>

<script setup>
import { ref, useSlots } from 'vue';

import {
  MDBModal,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-vue-ui-kit';

const slots = useSlots();

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
    validator(value) {
      return ['default', 'warning', 'danger'].includes(value);
    },
  },
  noBody: {
    type: Boolean,
    default: false,
  },

  isCentered: {
    type: Boolean,
    default: true,
  },
  isTitleBold: {
    type: Boolean,
    default: false,
  },
  hasCloseButton: {
    type: Boolean,
    default: true,
  },
});

const modalState = ref(false);
</script>

<style lang="scss" scoped>
:deep(.modal-content) {
  .modal-header {
    padding: 16px 24px 8px 24px;

    &.default {
      border-top: 8px solid $green-300;
    }

    &.warning {
      border-top: 8px solid $orange-300;
    }

    &.danger {
      border-top: 8px solid $red-300;
    }

    .modal-title {
      font-size: 16px;
      line-height: 24px;
      color: $neutral-800;

      label {
        font-weight: 500;
      }
    }

    button {
      margin-bottom: auto;
    }
  }

  .modal-body {
    padding: 16px 24px;

    .form-outline {
      .form-helper {
        color: $red-300;

        .form-counter {
          display: none;
        }
      }

      .form-control ~ .form-label {
        color: $neutral-500;
      }

      .form-control ~ .form-notch div {
        border-color: $neutral-50;
      }

      .form-control:focus ~ .form-label {
        color: $green-300;
      }

      .form-control:focus ~ .form-notch .form-notch-leading {
        border-top-color: $green-300;
        border-bottom-color: $green-300;
        border-left-color: $green-300;
      }

      .form-control:focus ~ .form-notch .form-notch-middle {
        border-color: $green-300;
      }

      .form-control:focus ~ .form-notch .form-notch-trailing {
        border-top-color: $green-300;
        border-bottom-color: $green-300;
        border-right-color: $green-300;
      }
    }
    .modal-radio .form-check {
      label {
        color: $neutral-400;
        font-size: 16px;
      }

      .form-check-input:checked,
      .form-check-input[type='radio']:checked:after {
        border-color: $green-300;
      }

      .form-check-input[type='radio']:checked:after {
        background-color: $green-300;
      }

      .form-check-input:checked:focus:before {
        box-shadow: none;
      }
    }
  }

  .modal-footer {
    padding: 20px 24px;
  }
}
</style>
